var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accbox"},[_c('div',{staticClass:"left"},_vm._l((_vm.menuList),function(item){return _c('listMenu',{key:item.name,attrs:{"itemData":item}})}),1),_c('div',{staticClass:"right"},[_c('keep-alive',[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }